// <-------- parallax section start ----------->

$(document).ready(function () {
  $(document).on("scroll", function () {
    let value = $(this).scrollTop();

    $("#train-parallax").css("right", value * 0.6 + "px");
    $("#moon-parallax").css("top", value * -0.2 + "px");
    $("#cloud-parallax").css("left", value * 0.4 + "px");
  });
});

// <---- section-img-scroll-animation start ----->

AOS.init();

// <---- section-img-scroll-animation end ----->

// <-------- parallax section end ----------->

// <-----------------------------slider start------------------->

$(".plyer-ammo-slider").owlCarousel({
  loop: false,
  margin: 30,
  dots: true,
  nav: false,
  // navText: ["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i></i>"],
  responsive: {
    0: {
      items: 1,
      margin: 10,
      stagePadding: 50,
    },
    768: {
      items: 2,
      margin: 10,
      stagePadding: 50,
    },
    1000: {
      items: 4,
    },
  },
});

$(".active-ingredients-slider, .community-slider").owlCarousel({
  loop: false,
  margin: 25,
  dots: true,
  nav: false,
  navText: [
    "<i class='fas fa-chevron-left'></i>",
    "<i class='fas fa-chevron-right'></i></i>",
  ],
  responsive: {
    0: {
      items: 1,
      margin: 30,
      nav: false,
      dots: true,
      stagePadding: 50,
    },
    768: {
      items: 2,
      margin: 30,
      nav: false,
      dots: true,
      stagePadding: 50,
    },
    1000: {
      items: 4,
    },
  },
});

$(".video-slider").owlCarousel({
  merge: true,
  loop: false,
  margin: 20,
  video: true,
  lazyLoad: true,
  dots: true,
  responsive: {
    0: {
      items: 1,
      margin: 30,
      dots: true,
      stagePadding: 50,
    },
    768: {
      items: 2,
      margin: 30,
      dots: true,
      stagePadding: 50,
    },
    1000: {
      items: 4,
    },
  },
});

// <------------------------------slider end------------------->

// <-------------togggle menu start-------------------->

$(".toggle-bar").click(function () {
  $(".header-box .menu-bar").addClass("active");
});

$(".close-icon").click(function () {
  $(".header-box .menu-bar").removeClass("active");
});

$(".menu-drawer-container").click(function () {
  $(".main_menu_icon_mobiletrg").css("display", "none");
  var drtg = jQuery(".menu-drawer-container").attr("value");
  if (drtg != 2) {
    $(".menu-drawer-container").attr("value", "1");
  }
});

$("#Details-menu-drawer-container").click(function () {
  var drtg = jQuery(".menu-drawer-container").attr("value");
  if (drtg == "1") {
    $(".menu-drawer-container").attr("value", "2");
  } else {
    $(".menu-drawer-container").attr("value", "1");
    $(".main_menu_icon_mobiletrg").css("display", "block");
  }
});

// <-------------togggle menu end-------------------->

// <-------------video-block start-------------------->

// $(".play-icon").click(function(){
//     $(this).parent().parent().find("video").get(0).play();
//     $(".play-icon").hide();
//     $(".pause-icon").show();
// });

// $(".pause-icon").click(function(){
//     $(this).parent().parent().find("video").get(0).pause();
//     $(".play-icon").show();
//     $(".pause-icon").hide();
// });

// <-------------video-block end-------------------->

$(function () {
  // Owl Carousel
  var owl = $(".owl-carousel");
  owl.owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1.4,
      },
      768: {
        items: 1.5,
      },
      1000: {
        items: 2.4,
      },
    },
  });
});

$(document).ready(function () {
  // slick carousel
  $(".slider-main").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow:
      '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
    asNavFor: ".slider-thumbs",
  });
  $(".slider-thumbs").slick({
    dots: true,
    vertical: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    verticalSwiping: false,
    arrows: true,
    asNavFor: ".slider-main",
    focusOnSelect: true,
  });
  if (screen.width < 768) {
    $(".slider-main-logos").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
      fade: false,
      loop: true,
    });
  } else {
    $(".slider-main-logos").slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
    });
  }
});

$(document).ready(function () {
  const scrollElements = document.querySelectorAll(".js-scroll");

  const elementInView = (el, dividend = 1) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
      elementTop <=
      (window.innerHeight || document.documentElement.clientHeight) / dividend
    );
  };

  const elementOutofView = (el) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
      elementTop > (window.innerHeight || document.documentElement.clientHeight)
    );
  };

  const displayScrollElement = (element) => {
    element.classList.add("scrolled");
  };

  const hideScrollElement = (element) => {
    element.classList.remove("scrolled");
  };

  const handleScrollAnimation = () => {
    scrollElements.forEach((el) => {
      if (elementInView(el, 1.25)) {
        displayScrollElement(el);
      } else if (elementOutofView(el)) {
        hideScrollElement(el);
      }
    });
  };

  window.addEventListener("scroll", () => {
    handleScrollAnimation();
  });
});

// Anime Page

// <---------- anim-icons Animation ---------->

var lFollowX = 0,
  lFollowY = 0,
  x = 0,
  y = 0,
  friction = 1 / 30;

function moveBackground() {
  x += (lFollowX - x) * friction;
  y += (lFollowY - y) * friction;

  translate = "translate(" + x + "px, " + y + "px) scale(1.1)";

  $(".anim-icons img").css({
    "-webit-transform": translate,
    "-moz-transform": translate,
    transform: translate,
  });
  $(".sticker img").css({
    "-webit-transform": translate,
    "-moz-transform": translate,
    transform: translate,
  });
  window.requestAnimationFrame(moveBackground);
}

$(window).on("mousemove click", function (e) {
  var lMouseX = Math.max(
    -100,
    Math.min(100, $(window).width() / 2 - e.clientX)
  );
  var lMouseY = Math.max(
    -100,
    Math.min(100, $(window).height() / 2 - e.clientY)
  );
  lFollowX = (20 * lMouseX) / 120; // 100 : 12 = lMouxeX : lFollow
  lFollowY = (10 * lMouseY) / 120;
});

moveBackground();

// Bottom Sticky

document.addEventListener("scroll", function () {
  const bottomSection = document.querySelector('#bottomSection');
  $(".product-form").waypoint(
    function (direction) {
      if (direction === "down") {
        bottomSection.classList.add('show');
      } else {
        bottomSection.classList.remove('show');
      }
    },
    { offset: "10%" }
  ); // Adjust the offset as needed
});

// Smooth scroll to section on button click

document.getElementById("scrollButton").addEventListener("click", function () {
  document.getElementById("MainContent").scrollIntoView({
    behavior: "smooth", // Smooth scroll behavior
  });
});
